module.exports = __webpack_public_path__ + "img/icon.d00f433a.svg";